import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';
import { Divider } from 'ui-components/common/Divider';
import { Keyword } from 'ui-components/contents/Keyword';

interface ContentDetailInfoMetaKeywordsProps {
  className?: string;
  keywords: string[];
  contestKeyword?: string;
}

export const ContentDetailInfoMetaKeywords = ({ className, keywords }: ContentDetailInfoMetaKeywordsProps) => {
  if (keywords.length <= 0) {
    return null;
  }

  return (
    <div className={className}>
      <StyledDivider color={Color.Gray200} />
      <StyledKeywords>
        {keywords.map(it => (
          <StyledKeyword key={it} keyword={it} />
        ))}
      </StyledKeywords>
    </div>
  );
};

const StyledKeyword = styled(Keyword)`
  padding: 2px 5px;
`;

const StyledDivider = styled(Divider)`
  position: relative;
  margin-bottom: 16px;
`;

const StyledKeywords = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  margin-top: -4px;
  margin-right: -4px;

  > * {
    margin-top: 6px;
    margin-right: 6px;
  }
`;
